<template>
    <div>
        <h1>{{ $t("pages.reset_access.title") }}</h1>
        <p>{{ $t("pages.reset_access.explanation") }}</p>

        <b-form>
            <b-form-group :label="$t('common.username')" label-for="username">
                <b-input-group>
                    <b-form-input id="username" type="text" v-model="rzaccount" :disabled="resetInProgress" :state="usernameValid">
                    </b-form-input>
                    <b-input-group-append-icon icon="person"/>
                    <!-- give the user feedback if the account name is invalid -->
                    <b-form-invalid-feedback>
                        <!-- callout for invalid username -->
                        <callout v-if="!usernameValid" callout-class="callout-danger" no-icon class="mb-0">
                            {{$t('pages.login.username_invalid')}}
                        </callout>
                    </b-form-invalid-feedback>
                </b-input-group>
            </b-form-group>

            <b-form-group :label="$t('common.password')" label-for="password">
                <b-input-group>
                    <b-form-input id="password" type="password" v-model="password" :disabled="resetInProgress" :state="passwordValid">
                    </b-form-input>
                    <b-input-group-append-icon icon="lock"/>
                </b-input-group>
            </b-form-group>
        </b-form>

        <!-- fancy submit button that shows a loading indicator until request is complete -->
        <b-overlay rounded opacity="0.6" spinner-small spinner-variant="primary" class="block mb-1" :show="sendingRequest">
            <template #overlay>
                <b-spinner small type="grow" variant="secondary"></b-spinner>
                <span class="sr-only">{{ $t('common.please_wait') }}</span>
            </template>

            <b-button @click="resetAccess" :disabled="resetInProgress || !valid" block variant="primary">
                <b-icon-arrow-clockwise/>
                {{ $t("pages.reset_access.start_reset") }}
            </b-button>
        </b-overlay>

        <div v-if="resetInProgress && countdownStarted" class="mb-1">
            <callout callout-class="callout-info" no-icon>
                <p>{{ $t("pages.reset_access.please_wait") }}</p>
                <b-progress :value="resetProgressTimeRemaining" :max="resetProgressTime">
                </b-progress>
            </callout>
        </div>

        <callout v-if="resetDone" callout-class="callout-success" class="mt-1">
            {{ $t("pages.reset_access.done") }}
        </callout>

        <callout v-if="error" callout-class="callout-danger" class="mt-1">
            {{ $t("pages.reset_access.error", {error: this.error}) }}
        </callout>

        <b-button size="sm" block href="/login">
            <b-icon-arrow-left/>
            {{ $t('pages.reset_access.go_back') }}
        </b-button>
    </div>
</template>

<script>
import BInputGroupAppendIcon from "../layout/BInputGroupAppendIcon";

export default {
    name: "ResetAccess",
    components: {BInputGroupAppendIcon},
    props: {
        regexAccount: {
            type: String,
            required: true
        },
        username: {
            type: String,
            required: false
        },
        resetAccessUrl: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            rzaccount: this.username,
            password: '',
            sendingRequest: false,
            resetInProgress: false,
            countdownStarted: false,
            resetFailed: false,
            resetDone: false,
            resetProgressTime: 20,
            resetProgressTimeRemaining: this.resetProgressTime,
            error: false,
            intervalID: undefined
        }
    },
    watch: {
        resetDone: function(done) {
            if(done) {
                this.$router.push('/login');
            }
        }
    },
    computed: {
        valid: function() {
            return this.usernameValid && this.password.length > 0;
        },
        usernameValid: function() {
            return this.rzaccount.length
                ? RegExp(`^${this.regexAccount}$`).test(this.rzaccount)
                : null; // null is neither valid nor invalid
        },
        passwordValid: function() {
            return this.password.length
                ? this.password.length > 3
                : null;
        }
    },
    methods: {
        startResetTimer() {
            this.resetProgressTimeRemaining = this.resetProgressTime;
            this.countdownStarted = true;
            this.intervalID = setInterval(
                () => {
                    if(this.resetProgressTimeRemaining === 0) {
                        clearInterval(this.intervalID);
                        this.resetInProgress = false;
                        this.resetDone = true;
                        this.countdownStarted = false;
                    } else {
                        this.resetProgressTimeRemaining--;
                    }
                },
                1000
            )
        },
        resetAccess: async function() {
            this.resetInProgress = true;
            this.resetDone = false;
            this.error = null;
            let response = null;
            try {
                this.sendingRequest = true;
                response = await this.$http.post(
                    this.resetAccessUrl + this.rzaccount,
                    {password: this.password}
                );
                if(response.data.data['hasBeenReset']) {
                    this.startResetTimer();
                } else {
                    this.error = this.$t('pages.reset_access.failed_generic');
                    this.resetFailed = true;
                    this.resetInProgress = false;
                }
            } catch (e) {
                if (e.response.data.error.message) {
                   this.error = e.response.data.error.message
                } else {
                    this.error = this.$t('pages.reset_access.failed_generic');
                }
                this.resetFailed = true;
                this.resetInProgress = false;
            } finally {
                this.sendingRequest = false;
            }
        }
    }
}
</script>

<style scoped>

</style>
